export enum ActivityTypeToFetch {
  INSTRUCT = "INSTRUCT",
  TUTOR = "TUTOR",
  BOTH = "BOTH"
}

export default ActivityTypeToFetch;